import { useState } from "react";
import { CompanyUploadedReview } from "@/components/dokumenti/CompanyUploadedReview";
import { Button } from "@/components/ui/button";
import type { ObvezaTvrtke } from "@/lib/companyObligations";
import { InboxUploadForm } from "@/pages/DocumentInboxUploadPage";

export function ObligationEvidenceUpload({ obligation, onBack, onSaved }: { obligation: ObvezaTvrtke; onBack: () => void; onSaved: () => void }) {
  const [ids, setIds] = useState<string[]>([]);
  return <div className="flex h-full min-h-0 flex-col gap-3 p-3" aria-label="Učitaj dokaz obveze">
    {ids.length ? <CompanyUploadedReview compact ids={ids} onFinished={onSaved} /> : <><Button variant="outline" className="shrink-0 self-start" onClick={onBack}>← Natrag na obvezu</Button><div className="flex min-h-0 flex-1 flex-col overflow-y-auto"><InboxUploadForm obligation={obligation} compact onCompanyUploaded={setIds} /></div></>}
  </div>;
}
